<template>
  <CHeader fixed with-subheader light class="justify-content-between">
    <CToggler
      in-header
      class="ml-3 d-lg-none"
      @click="$store.commit('toggleSidebarMobile')"
    />
    <CToggler
      in-header
      class="ml-3 d-md-down-none"
      @click="$store.commit('toggleSidebarDesktop')"
    />
    <CHeaderBrand class="mx-auto d-lg-none" to="/">
      <img src="../assets/headerLogo.png">
    </CHeaderBrand>
    <select v-model="currentLanguage">
      <option value="en">{{$t("english")}}</option>
      <option value="pt">{{$t("portuguese")}}</option>
    </select>
  </CHeader>
</template>

<script>
export default {
  name: 'TheHeader',
  data()
  {
    return {
      currentLanguage: this.$i18n.locale,
    }
  },
  watch:
  {
    currentLanguage: function(val)
    {
      this.$i18n.locale = val;
      localStorage.setItem('locale', val);

      let getQueries = Object.entries(this.$route.query);
      this.$router.push({
        params: { lang: val },
        query: getQueries ? Object.fromEntries(getQueries) : null
      })

      this.$router.go(0);
    }
  }
}
</script>

<style scoped>
body > div > div.c-wrapper > header > a > img
{
  height: 48px;
  width: auto;
}
select
{
  background: transparent;
  border: none;
  color: white;
  padding-right: 0.5rem;
  margin-right: 1rem;
  cursor: pointer;
}

select > option
{
  color: black;
}
</style>